import type React from 'react';

import { Helmet } from 'react-helmet-async';

import { useI18n } from '@change-corgi/core/react/i18n';

import { OG_IMAGE } from 'src/app/pages/about/impact/shared/consts';

export const PageMeta: React.FC = () => {
	const { translate } = useI18n();

	return (
		<Helmet>
			<meta property="og:title" content={translate('fe.pages.impact.victories.every_hour')} />
			<meta property="og:description" content={translate('fe.pages.about.section_victories.description')} />
			<meta property="og:image" content={OG_IMAGE} />
			<meta property="twitter:image" content={OG_IMAGE} />
			<meta property="twitter:image:alt" content={translate('fe.pages.impact.victories.every_hour')} />
			<meta property="og:type" content="website" />
			<meta property="twitter:card" content="summary" />
			<title>{translate('fe.pages.impact.title_tag')}</title>
		</Helmet>
	);
};
